import { render, staticRenderFns } from "./RaceCardRaceComments.vue?vue&type=template&id=93df15e2&scoped=true"
import script from "./RaceCardRaceComments.vue?vue&type=script&lang=js"
export * from "./RaceCardRaceComments.vue?vue&type=script&lang=js"
import style0 from "./RaceCardRaceComments.vue?vue&type=style&index=0&id=93df15e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93df15e2",
  null
  
)

export default component.exports